import {getPaymentMethods, storePaymentMethod, deletePaymentMethod, setPaymentMethodAsDefault} from "@/api/payment";

const state = {
    payment_methods: [],
    default_payment_method_id: null,
    client_secret: null,
}

const getters = {
    methods: state => state.payment_methods,
    default_payment_method_id: state => state.default_payment_method_id,
    client_secret: state => state.client_secret,
}

const mutations = {
    SET_PAYMENT_METHODS(state, response) {
        state.payment_methods = response.data;
        state.default_payment_method_id = response.default_payment_method_id;
    },

    PUSH_ONE_PAYMENT_METHOD(state, response) {
        state.payment_methods.push(response.data);
    },

    DELETE_ONE_PAYMENT_METHOD(state, id) {
        state.payment_methods = state.payment_methods.filter(payment_method => payment_method.id !== id);
    },

    UPDATE_DEFAULT_PAYMENT_METHOD(state, id) {
        state.default_payment_method_id = id;
    },
}

const actions = {
    clearState({commit}) {
        commit('SET_PAYMENT_METHODS', []);
    },

    getPaymentMethods({commit}) {
        getPaymentMethods().then(response => {
            commit('SET_PAYMENT_METHODS', response)
        })
    },

    storePaymentMethod(_, id) {
        return new Promise((resolve, reject) => {
            storePaymentMethod(id).then(response => {
                // commit('PUSH_ONE_PAYMENT_METHOD', response)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },

    deletePaymentMethod({commit}, id) {
        return new Promise((resolve, reject) => {
            deletePaymentMethod(id).then(response => {
                commit('DELETE_ONE_PAYMENT_METHOD', id)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },

    setPaymentMethodAsDefault({commit}, id) {
        return new Promise((resolve, reject) => {
            setPaymentMethodAsDefault(id).then(response => {
                commit('UPDATE_DEFAULT_PAYMENT_METHOD', id)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
